import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';

// flex-direction (dir)
const flexDirection = ({
  ltr: 'row',
  rtl: 'row-reverse',
  ttb: 'column',
  btt: 'column-reverse',
  default: 'row',
});

// wrap (flex-wrap)
const flexWrap = ({
  none: 'nowrap',
  wrap: 'wrap',
  [true]: 'wrap',
  reverse: 'wrap-reverse',
  default: 'nowrap',
});

// just (justify-content)
const justifyContent = ({
  s: 'flex-start',
  e: 'flex-end',
  c: 'center',
  b: 'space-between',
  a: 'space-around',
  default: 'flex-start',
});

// align (align-items)
const alignItems = ({
  s: 'flex-start',
  e: 'flex-end',
  c: 'center',
  b: 'baseline',
  f: 'stretch', // fill
  default: 'flex-start',
});

// justGroups (align-content)
const alignContent = ({
  s: 'flex-start',
  e: 'flex-end',
  c: 'center',
  b: 'space-between',
  a: 'space-around',
  f: 'stretch', // fill
  default: 'stretch',
});

// self (align-self)
const alignSelf = ({
  s: 'flex-start',
  e: 'flex-end',
  c: 'center',
  b: 'baseline',
  f: 'stretch', // fill
  default: 'auto',
});

/**
 * Reusable, General, Flexible (lol) Flex Component
 * Contains multiple shorthands for flex settings:
 * set prop to set value based on mapping above
 * i.e.
 * setting @prop 'self' as 's' will make component use `align-self: 'flex-start'`
 **/
export default class Flex extends Component {
  static propTypes = {
    tag: PropTypes.string,
    props: PropTypes.object,
  };

  static defaultProps = {
    tag: 'div',
    h: '100%',
    w: '100%',
  };


  render() {
    const {
      dir,
      wrap,
      justGroups,
      self,
      c,
      grow,
      h,
      w,
      children,
      className,
    } = this.props;
    let { just, align } = this.props

    const pathOr = (map, path) => _.get(map, path, map.default);

    // center shortcut for single item
    if (c) {
      just = 'c';
      align = 'c';
    }

    let style = {
      display: 'flex',
      height: h,
      width: w,
      flexDirection: pathOr(flexDirection, dir),
      flexWrap: pathOr(flexWrap, wrap),
      justifyContent: pathOr(justifyContent, just),
      alignItems: pathOr(alignItems, align),
      alignContent: pathOr(alignContent, justGroups),
      alignSelf: pathOr(alignSelf, self),
      flexGrow: grow,
      ...this.props.style
    }
    style = _.omit(style, ['dir', 'wrap', 'just', 'align', 'justGroups', 'self', 'grow', 'c', 'innerKey'])

    return (
      <div
        className={className}
        style={style}
      >
        {children}
      </div>
    )
  }
}